<template>
    <div class="ku-place">

        <div class="top">
            <div class="title">申请您的专享折扣</div>
            <div class="tit" v-if="discount > 0">您当前下单可享受{{ discount }}折</div>
            <div class="br">
                <van-field v-model="mobile" placeholder="请输入您的手机号" />
                <van-button type="warning" @click="seat">提交</van-button>
            </div>
        </div>

    </div>
</template>

<script>
    import Vue from 'vue';
    import {Field, Button, Dialog, Image as VanImage, Popup, Col, Row} from 'vant';

    Vue.use(Field).use(Button).use(Dialog).use(VanImage).use(Popup).use(Col).use(Row);
    export default {
        name: "index",
        data() {
            return {
                discount: 0,
                mobile: '',
            }
        },
        mounted() {
            this.getUserMoney();
        },
        methods: {
            // 获取用户余额
            getUserMoney() {
                let that = this
                // 获取用户余额
                that.$API.getUserMoney({shop_id: that.shop_id}).then(res => {
                    that.discount = res.data.data.discount

                    that.getSite();
                })
            },
            seat() {
                let that = this
                if (that.mobile === '') {
                    Dialog.alert({
                        message: '请输入手机号',
                    })
                    return false;
                }
                this.$API.getGroupApply({
                    mobile: that.mobile
                }).then(res => {
                    if (res.data.code === 1) {
                        that.mobile = ''
                        Dialog.alert({
                            message: '提交成功，请等待审核',
                        })
                    } else {
                        Dialog.alert({
                            message: res.data.msg,
                        })
                    }
                })
            },
        },
    }
</script>

<style lang="less" scoped>
.ku-place {
    height: 100%;
    width: 100%;
    position: fixed;
    background: #009C90;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;

    .top {
        width: 98%;
        height: 98%;
        border: 1px solid #fff;
        margin: auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        .title {
            color: #ffffff;
            font-size: 70px;
            padding-top: 200px;
        }
        .tit {
            color: #FFF100;
        }
        .br {
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding-top: 200px;

            .van-field {
                width: 70%;
                height: 80px;
                font-size: 26px;
                line-height: 80px;
                text-align: center;
                color: #000;
                padding: 0;
                margin: 0 auto;
                border-radius: 20px;
                /deep/ .van-field__control {
                    text-align: center;
                }
            }

            .van-button {
                width: 200px;
                height: 80px;
                border-radius: 20px;
                font-size: 30px;
                padding: 0;
                color: #000;
                margin: 50px auto;
                background: #ffffff;
                border-color: #ffffff;
            }
        }
    }
}
</style>
